import { IntegrationServiceId } from '../../../../../common/integrations'
import { CreatorService } from '../../PastMeetings/CreatorIcon'

export const creatorServiceToNameMap: { [key in CreatorService]: string } = {
  [IntegrationServiceId.GOOGLE_CALENDAR]: 'Google Calendar',
  [IntegrationServiceId.OUTLOOK_CALENDAR]: 'Outlook Calendar',
  [IntegrationServiceId.EXCHANGE_CALENDAR]: 'Exchange Calendar',
  [IntegrationServiceId.REDTAIL]: 'Redtail Calendar',
  [IntegrationServiceId.WEALTHBOX]: 'Wealthbox Calendar',
  email: 'Email invite',
  'voice-memo': 'Zocks',
  import: 'Zocks',
}
